module.exports = __webpack_public_path__ + "static/media/2_pl.787c1f95.png";